import { AfterViewInit ,Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { DataTableEsp, status } from 'src/app/shared/config/config';
import { Subject, firstValueFrom } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableRootObject, DtCallback, LogsNav, Petition, User, petitionDatatableItem } from 'src/app/interfaces/interfaces.index';
import Swal from 'sweetalert2';
import { swalError, swalInfo, swalSuccess, swalDesition } from 'src/app/shared/config/swalCommon';
import { PeticionService, UserService, AdviserService, DocumentService, LogsService } from 'src/app/services/services.index';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ConcessionaireAdviser } from 'src/app/interfaces/adviser';
import * as moment from 'moment';
import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlDocumentalComponent } from '../documentos/control-documental/control-documental.component';

export interface Solicitud {
  Solicitud: string;
  Cliente: string;
  Fecha: string;
  Asesor: string;
  Estado: string;
}

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.css']
})
export class SolicitudesComponent implements OnInit{
  petitions: petitionDatatableItem[] = [];

  dtOptions: DataTables.Settings = {};
  dtLanguage: {} = DataTableEsp;
  dtTrigger: Subject<void> = new Subject<void>();
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;

  role: string = this.userService.user.role;
  mode: string;
  rol: string;

  user: User = this.userService.user;
  adviserId: any;
  concessionaire: ConcessionaireAdviser;
  infoAdviser: ConcessionaireAdviser;
  proceso: number;

  firstTime = JSON.parse(sessionStorage.getItem('firstAccess'));

  petitionsControl: boolean = true;
  documentsRejected = [];
  petition: Petition;
  status = status;

  constructor(
    public router: Router,
    private userService: UserService,
    private SpinnerService: NgxSpinnerService,
    private peticionService: PeticionService,
    private route: ActivatedRoute,
    private adviserService: AdviserService,
    private documentService: DocumentService,
    private modal: NgbModal,
    private logsService: LogsService
  ) {

    this.dtOptions = {
      retrieve: true,
      order: [[0, 'desc']],
      columnDefs: [],
      language: this.dtLanguage,
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: DatatableRootObject, callback) => this.consult(dataTablesParameters, callback),
      columns: [
        { data: 'contractNumber' },
        { data: 'quotaNumber' },
        { data: 'userName' },
        { data: 'role' },
        { data: 'date' },
        { data: 'status' },
        { data: 'process' },
        { data: 'options', defaultContent: '', searchable: false, orderable: false }
      ]
    };

    this.route.paramMap.subscribe((res: any) => {
      this.mode = res.params.mode;
      this.rol = res.params.profile;
    });
    if (this.rol === 'admin' && !this.getRole(['Administrador de proceso', 'Super administrador'])) { this.router.navigate([`login`]); }

    setTimeout(() => this.authDocumentsRejected(), 1000);
  }
  authDocumentsRejected = () => {
    this.documentService.getAllDocumentsByUserId(this.user.id, 'enrollment', this.user.role == 'Asesor integral'? true : false).subscribe(
      data => {
        const dataMap = Object.values(data);
        let countRejected = 0;
        dataMap.map(val => {
          if (val.documentStatus == 2) {
            countRejected++;
            this.documentsRejected.push(val);
          }
        });
        if (countRejected > 0) {
          Swal.fire(swalDesition('Tienes documentos rechazados, ¿Deseas corregirlos?'))
          .then(res => {
            if (res.value) {
              const openCorrectDocuments = this.modal.open(ControlDocumentalComponent, { size: 'xl', centered: true, backdrop: 'static' });
              openCorrectDocuments.componentInstance.documentsCorrection = this.documentsRejected;
              openCorrectDocuments.componentInstance.documentType = 'enrollment';
            }
          })
        }
      }
    );
  };

  haveData = (data: any) => data.length == 0 ? false : true;

  ngOnInit(): void {
    this.adviserService.redirectToProcess.next(null);
    this.addLogsNav();

    if (this.firstTime == true) {
      sessionStorage.removeItem('firstAccess');
      sessionStorage.setItem('firstAccess', JSON.stringify(false));
    }

    if (this.getRole(['Asesor integral'])) {
      this.adviserService.getAdviserConcessionaire(this.user.id).subscribe(data => {
        this.concessionaire = data;
        this.adviserService.addAdviserInfoStore(data);
        this.dtTrigger.next();
      });
    }
    else setTimeout(() => this.dtTrigger.next(), 60);

    this.adviserService.redirectToProcess.subscribe(res => {
      if(res)
        this.continueProcess({} as petitionDatatableItem, res.petitionId, res.userId);
    });
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  getConcesionari(id: number) {
    this.adviserService.getAdviserConcessionaire(id).subscribe( data => {
      this.infoAdviser = data;
      this.adviserService.addAdviserInfoStore(this.infoAdviser);
    });
  }

  getPetitionByUser(user: User) {
    this.peticionService.getPetitionsByUser(user).subscribe(res => {
      this.petitionsControl = this.haveData(res);
      if (this.mode === 'inicio' && res.length === 1) { this.verProceso(res[0]); }
    }, err => this.handleError(err));
  }

  consult(dataTablesParameters: DatatableRootObject, callback: (data: DtCallback) => void) {
    const adviserUserId = this.concessionaire ? this.userService.user.id : 0;
    this.peticionService.getPetitionByAdviser(dataTablesParameters, adviserUserId).subscribe(data => {
      this.petitionsControl = false;
      this.petitions = data.data;
      this.petitionsControl = this.haveData(data.data);
      callback({
        recordsTotal: data.recordsTotal,
        recordsFiltered: data.recordsFiltered,
        data: []
      });
    });
  }

  ngOnDestroy = () => {
    this.dtTrigger.unsubscribe();
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }

  getRole(rolls: string[]) {
    let retorno: boolean;
    rolls.indexOf(this.role) !== -1 ? retorno = true : retorno = false;
    return retorno;
  }

  verProceso = (petition: Petition) => {
    sessionStorage.setItem('selPetition', JSON.stringify(petition));
    this.router.navigate([`proceso`]);
  }

  async continueProcess(petition: petitionDatatableItem, petitionId?: number, userId?: number) {
    if(petitionId)
      petition = this.getPetitionFromId(petitionId, userId);

    if(petition)
    {
      this.SpinnerService.show();
      await firstValueFrom(this.peticionService.getPetitionById(petition.petitionId)).then(res => {
        this.petition = res;
        this.SpinnerService.hide();
      }).catch(err => {
        this.handleError(err);
      });

      this.peticionService.addPetitionAdviserStore(this.petition);
      // La selección de la bandeja de tareas no aplica a esta solicitud: si queda en sesión
      // tiene prioridad y se consultan los documentos de otro usuario.
      sessionStorage.removeItem('selectedUserIdFromBandeja');
      sessionStorage.setItem('AdjudgedUserId', JSON.stringify(petition.userId));
      this.userService.currentPetitionUserId = petition.userId;

      switch (petition.processId) {
        case 5:
          this.router.navigate(['validacion-documental', 1]);
          break;

        case 6:
          this.router.navigate(['/respuesta-credito']);
          break;

        case 10:
          this.router.navigate([`proceso-capacidad-pago`, 2])
          break;

        case 11:
          this.router.navigate(['cotizaciones']);
          break;

        case 12:
          this.router.navigate(['/estudio-capacidad-pago']);
          break;

        case 15:
          this.router.navigate(['seleccion-vehiculo', 2]);
          break;

        case 16:
          this.router.navigate(['carga-factura', 1]);
          break;

        case 17:
          this.router.navigate(['validacion-documental', 2]);
          break;

        case 19:
          this.router.navigate(['gestion-seguros', petition.petitionId, 1]);
          break;

        case 20:
          this.router.navigate(['autorizacion-factura']);
          break;

        case 21:
          this.router.navigate(['seguimiento-proceso']);
          break;

        case 22:
          this.router.navigate(['carga-factura', 2]);
          break;

        case 23:
          this.router.navigate(['validacion-documental', 4]);
          break;

        case 25:
          this.router.navigate(['gestion-seguros', petition.petitionId, 2]);
          break;

        case 26:
          this.router.navigate(['carga-tarjeta-propiedad', 1]);
          break;

        case 27:
          const navigationExtras: NavigationExtras = {
            queryParams: { 'step': 2 }
          };

          this.router.navigate(['validacion-documental', 5], navigationExtras);
          break;

        case 28:
          this.router.navigate(['autorizacion-entrega']);
          break;

        case 29:
          this.router.navigate(['cita-entrega-asesor']);
          break;

        case 30:
          this.router.navigate(['carga-tarjeta-propiedad', 2]);
          break;

        case 31:
          if(petition.status === "Completed")
            Swal.fire(swalInfo('¡Proceso terminado!', 'Ya se completaron todas las fases con el adjudicado'));
          else
            this.router.navigate(['validacion-documental', 6]);
          break;

        default:
          Swal.fire(swalInfo('¡En espera!', 'Debe esperar a que el adjudicado continúe el proceso'));
          break;
      }
    }
    else
    {
      this.SpinnerService.show();
      await firstValueFrom(this.peticionService.getPetitionById(petitionId)).then(res => {
        this.petition = res;
        this.SpinnerService.hide();
      }).catch(err => {
        this.handleError(err);
      });

      this.peticionService.addPetitionAdviserStore(this.petition);
      sessionStorage.removeItem('selectedUserIdFromBandeja');
      sessionStorage.setItem('AdjudgedUserId', JSON.stringify(userId));
      this.userService.currentPetitionUserId = userId;

      switch (this.petition.processId) {
        case 5:
          this.router.navigate(['validacion-documental', 1]);
          break;

        case 6:
          this.router.navigate(['/respuesta-credito']);
          break;

        case 10:
          this.router.navigate([`proceso-capacidad-pago`, 2])
          break;

        case 11:
          this.router.navigate(['cotizaciones']);
          break;

        case 12:
          this.router.navigate(['/estudio-capacidad-pago']);
          break;

        case 15:
          this.router.navigate(['seleccion-vehiculo', 2]);
          break;

        case 16:
          this.router.navigate(['carga-factura', 1]);
          break;

        case 17:
          this.router.navigate(['validacion-documental', 2]);
          break;

        case 19:
          this.router.navigate(['gestion-seguros', this.petition.id, 1]);
          break;

        case 20:
          this.router.navigate(['autorizacion-factura']);
          break;

        case 21:
          this.router.navigate(['seguimiento-proceso']);
          break;

        case 22:
          this.router.navigate(['carga-factura', 2]);
          break;

        case 23:
          this.router.navigate(['validacion-documental', 4]);
          break;

        case 25:
          this.router.navigate(['gestion-seguros', this.petition.id, 2]);
          break;

        case 26:
          this.router.navigate(['carga-tarjeta-propiedad', 1]);
          break;

        case 27:
          const navigationExtras: NavigationExtras = {
            queryParams: { 'step': 2 }
          };

          this.router.navigate(['validacion-documental', 5], navigationExtras);
          break;

        case 28:
          this.router.navigate(['autorizacion-entrega']);
          break;

        case 29:
          this.router.navigate(['cita-entrega-asesor']);
          break;

        case 30:
          this.router.navigate(['carga-tarjeta-propiedad', 2]);
          break;

        case 31:
          if(this.petition.processStatus === "Completed")
            Swal.fire(swalInfo('¡Proceso terminado!', 'Ya se completaron todas las fases con el adjudicado'));
          else
            this.router.navigate(['validacion-documental', 6]);
          break;

        default:
          Swal.fire(swalInfo('¡En espera!', 'Debe esperar a que el adjudicado continúe el proceso'));
          break;
      }
    }
  }

  cantContinue(petition: petitionDatatableItem): boolean {

    if([17].includes(petition.processId)){
      if(petition.role == 'Cliente' && petition.status == 'InProcessSecondHolder'){
            return true
      }
    }

    if([28].includes(petition.processId)&&petition.status == "Postponed")
        return false
    const result = ([3, 4, 8, 9, 13, 14, 18, 24].includes(petition.processId) || petition.status !== "InProcess") ;
    return result;
  }

  async goTo(pantalla: string, petition: petitionDatatableItem) {
    this.SpinnerService.show();
    await firstValueFrom(this.peticionService.getPetitionById(petition.petitionId)).then(res => {
      this.petition = res;
      this.SpinnerService.hide();
    }).catch(err => {
      this.handleError(err);
    });

    this.peticionService.addPetitionAdviserStore(this.petition);

    if(pantalla === "seguimiento")
      this.router.navigate(['seguimiento-proceso'])
    else
      this.router.navigate(['cita-entrega-asesor'])
  }

  showMonitoring(petition: petitionDatatableItem): boolean {
    if(petition.processId < 23 && (petition.status === "Postponed"  || petition.status === "Completed"))
      return false;
    else
      return true;
  }

  showAppointment(petition: petitionDatatableItem): boolean {
    if(petition.processId < 29 || petition.status === "Completed")
      return false;
    else
      return true;
  }

  getPetitionFromId(petitionId: number, userId: number): petitionDatatableItem {
    return this.petitions.find(x => x.petitionId === petitionId && x.userId === userId);
  }
}
